import React from 'react'
import { connect } from 'react-redux';


import { getForms, deleteForm, resetSelectedForm } from '../../../store/forms/actions';
import DeleteDialog from './DeleteDialog';

function DeleteForm (props) {
    const { selectedForm, getForms, resetSelectedForm, handleClose } = props;
    if(!selectedForm) return null;

    const handleDelete = () => {
        deleteForm(selectedForm.urlFormId)
            .then(() => {
                getForms();
                resetSelectedForm();
                handleClose();
            })
            .catch(error => console.log(error));
    };

    return (
        <DeleteDialog
            handleClose={handleClose}
            handleDelete={handleDelete}
            form={selectedForm}
        />
    );
}

const mapStateToProps = (state) => ({
    selectedForm: state.forms.selected,
});

const mapDispatchToProps = dispatch => ({
    resetSelectedForm: () => dispatch(resetSelectedForm()),
    getForms: () => dispatch(getForms())
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteForm);
